import React from 'react';
import { HiOutlineUserPlus, HiOutlineClipboardDocumentCheck, HiOutlineUserGroup } from "react-icons/hi2";
import { useState } from 'react';
import { Navigate } from "react-router-dom";

function UserAdminButtons() {
  const [rollSender, setRollSender] = useState("");
  const roll = parseInt(localStorage.getItem('userRoll'));

  function handleRoll1() {
    setRollSender(1);
  }
  function handleRoll2() {
    setRollSender(3);
  }

  if (rollSender) {
    const route = `/user-registration-employees?rollSender=${rollSender}`;
    return <Navigate to={route} />;
  }

  return (
    <div className="flex flex-col items-center justify-center w-full px-4 py-8 gap-8" data-testid="user-admin-buttons-container">
      {roll === 1 && (
        <>
          <div className="w-full max-w-md" data-testid="user-admin-buttons-admin-button-container">
            <button
              onClick={handleRoll1}
              className="w-full px-6 py-4 text-gray-900 text-lg font-semibold rounded-lg shadow-md flex items-center justify-between relative overflow-hidden group"
              data-testid="user-admin-buttons-create-admin-button"
            >
              <div className="absolute inset-0 bg-gradient-to-t from-amber-300 to-amber-700 transition-transform duration-700 ease-in-out"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-amber-300 to-amber-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
              <span className="z-10 flex items-center" data-testid="user-admin-buttons-create-admin-text">
                <HiOutlineUserPlus className="text-2xl mr-3" />
                Crear usuarios (Admins)
              </span>
              <svg className="z-10 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>

          <div className="w-full max-w-md" data-testid="user-admin-buttons-vigilante-button-container">
            <button
              onClick={handleRoll2}
              className="w-full px-6 py-4 text-gray-900 text-lg font-semibold rounded-lg shadow-md flex items-center justify-between relative overflow-hidden group"
              data-testid="user-admin-buttons-create-vigilante-button"
            >
              <div className="absolute inset-0 bg-gradient-to-t from-amber-300 to-amber-700 transition-transform duration-700 ease-in-out"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-amber-300 to-amber-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
              <span className="z-10 flex items-center" data-testid="user-admin-buttons-create-vigilante-text">
                <HiOutlineUserPlus className="text-2xl mr-3" />
                Crear usuarios (Vigilantes)
              </span>
              <svg className="z-10 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>

          <div className="w-full max-w-md" data-testid="user-admin-buttons-requests-link-container">
            <a 
              href="/user-registration-request" 
              className="w-full px-6 py-4 text-white text-lg font-semibold rounded-lg shadow-md flex items-center justify-between relative overflow-hidden group"
              data-testid="user-admin-buttons-registration-requests-link"
            >
              <div className="absolute inset-0 bg-gradient-to-t from-purple-300 to-purple-700 transition-transform duration-700 ease-in-out"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-purple-300 to-purple-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
              <span className="z-10 flex items-center" data-testid="user-admin-buttons-registration-requests-text">
                <HiOutlineClipboardDocumentCheck className="text-2xl mr-3" />
                Solicitudes de registro
              </span>
              <svg className="z-10 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
        </>
      )}
      
      <div className="w-full max-w-md" data-testid="user-admin-buttons-users-list-container">
        <a 
          href="/users-administration-list" 
          className="w-full px-6 py-4 text-white text-lg font-semibold rounded-lg shadow-md flex items-center justify-between relative overflow-hidden group"
          data-testid="user-admin-buttons-users-list-link"
        >
          <div className="absolute inset-0 bg-gradient-to-t from-purple-300 to-purple-700 transition-transform duration-700 ease-in-out"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-purple-300 to-purple-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
          <span className="z-10 flex items-center" data-testid="user-admin-buttons-users-list-text">
            <HiOutlineUserGroup className="text-2xl mr-3" />
            Lista de usuarios
          </span>
          <svg className="z-10 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </a>
      </div>
    </div>
  );
}

export { UserAdminButtons };
